import { ContractInfos, Plan } from '../../apiTypes';

export const name = 'admin';

export const types = {
    SET_CONTRACT: `${name}/SET_CONTRACT`,
    SET_CONTRACT_PLAN: `${name}/SET_CONTRACT_PLAN`,
    CLEAR_ALL: `${name}/CLEAR_ALL`,
};

export interface CurrentGroupState {
    contract: ContractInfos;
    plan: Plan;
}

// InitialState
const initialState: CurrentGroupState = {
    contract: null,
    plan: null,
};

const reducer = (state = initialState, action: any = {}): any => {
    switch (action.type) {
        case types.SET_CONTRACT:
            return {
                ...state,
                contract: action.payload.contract,
            };
        case types.SET_CONTRACT_PLAN:
            return {
                ...state,
                plan: action.payload.plan,
            };
        case types.CLEAR_ALL:
            return initialState;
        default:
            return state;
    }
};
export default reducer;

// ActionCreators
export const actions = {
    setContract: (contract: ContractInfos): any => ({ type: types.SET_CONTRACT, payload: { contract } }),
    setContractPlan: (plan: Plan): any => ({ type: types.SET_CONTRACT_PLAN, payload: { plan } }),
    resetAll: (): any => ({ type: types.CLEAR_ALL }),
};

const localState = (state: any): CurrentGroupState => state[name] || initialState;
export const selectors = {
    contract: (state): ContractInfos => localState(state).contract,
    contractPlan: (state): Plan => localState(state).plan,
};
